import { debounce } from 'radashi'
import { defineComponent } from '~/scripts/utils/alpine'

export default defineComponent(() => ({
  value: document.documentElement.dataset.mode ?? 'candidate',
  clipPath: '',
  items: {} as Record<string, HTMLLabelElement>,
  init() {
    const inputs = this.$root.querySelectorAll<HTMLInputElement>(
      'input[type="radio"]',
    )
    for (const input of inputs) {
      this.items[input.value] = input.closest('label')!
    }
    const observer = new ResizeObserver(
      debounce({ delay: 50 }, () => this.update()),
    )

    observer.observe(this.$root)

    this.update()
    this.$watch('value', (value) => {
      this.update()

      // Redirect to the corresponding homepage (candidate or company)
      const input = this.$root.querySelector<HTMLInputElement>(
        `input[value="${value}"]`,
      )
      if (input?.dataset.url) {
        globalThis.location.href = input.dataset.url
      }
    })
  },
  update() {
    const label = this.items[this.value]
    const padding = 3

    if (label) {
      const top = label.offsetTop + padding
      const right = label.offsetLeft + label.offsetWidth - padding
      const bottom = label.offsetTop + label.offsetHeight - padding
      const left = label.offsetLeft + padding

      this.clipPath = `rect(${top}px ${right}px ${bottom}px ${left}px round 999px)`
    } else {
      this.clipPath = ''
    }
  },
  onClick(mode: string, url: string) {
    // If the mode is already selected, redirect to the corresponding homepage
    if (this.value === mode) {
      globalThis.location.href = url
    }
  },
}))
